var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewmore",staticStyle:{"cursor":"pointer"}},[_c('p',[_vm._v(_vm._s(_vm.$t("common.viewmore")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }